import React from "react"
import { NavLink } from "react-router-dom"

import "./index.css"

type AppMenuParams = { children: React.ReactNode }

export function AppMenu({ children }: AppMenuParams) {
  return <ul className="hux-menu">{children}</ul>
}

type AppMenuItemParams = { children: React.ReactNode; to: string }

export function AppMenuItem({ children, to }: AppMenuItemParams) {
  return (
    <li className="hux-menu-item">
      <NavLink to={to}>{children}</NavLink>
    </li>
  )
}
